import type {MenuModel} from "../types";
import AppSubMenu from "./AppSubMenu";
import {routes} from "../Router/route";

const AppMenu = () => {
    const model: MenuModel[] = [
        {
            label: "Dashboards",
            icon: "pi pi-home",
            items: [
                {
                    label: "Home",
                    icon: "pi pi-fw pi-home",
                    to: routes.home,
                },
                {
                    label: "Orders",
                    icon: "pi pi-fw pi-image",
                    to: routes.orders,
                },
            ],
        },

    ];

    return <AppSubMenu model={model}/>;
};

export default AppMenu;
